import { Language } from '../language'
import { RoleType } from '../../utils/jwtUtils'

export enum ThemeType {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum BannerKind {
  OK = 'ok',
  ERR = 'err',
  WARN = 'warn',
  INFO = 'info',
}

export interface Banner {
  kind: BannerKind
  msg: string
}

export interface AppContextType {
  theme: ThemeType
  setTheme: (theme: ThemeType) => void
  lang: Language
  setLang: (language: Language) => void
  roles: RoleType[]
  showBanner: (b: Banner) => void
}
